export class LockUnlock {
  public bookingMasterHashId: string;
  public locationDataExchangeHashId: string;
  public isMobileRequest: boolean = false;
 public contractTypeGroupId: number;
 public tripHashId:string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/lockunlock.model.ts